module.exports = __webpack_public_path__ + "static/media/NunitoSans-ExtraBold.f993cfe8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NunitoSans-ExtraBold.woff
// module id = 3433
// module chunks = 68